/**
 * 🧱 Refactor BT Phase 4 — B-26 : le Pointage terrain ne garde que les bons d'AUJOURD'HUI.
 * Règle validée par l'utilisatrice (2026-09-30) : un bon `is_tomorrow` / `day_label === 'tomorrow'`
 * reste visible dans « Mon espace » (section DEMAIN) mais ne s'affiche ni ne se punche dans le Pointage.
 */
export function bonsDuJourSeulement(bons) {
  return (bons || []).filter(b => b && b.is_tomorrow !== true && (b.day_label ?? 'today') !== 'tomorrow');
}
